import React from 'react'
import V2Layout from '../../components/V2Layout'
import SEO from '../../components/SEO'
import CapabilityPageNav from './CapabilityPageNav'
import CapabilitySections from './CapabilitySections'
import '../../versions/v2/capabilities.css'

const EnvironmentalTestingPage = () => (
    <V2Layout pageClass="pfc-capabilities">
        <SEO
            title="Environmental Testing - Martin Test Labs"
            description="Vibration, shock, thermal, vacuum, and mechanical testing, all performed in-house at Martin Testing Labs, a PFC company."
        />
        <section className="pfc-page-hero">
            <div className="pfc-page-hero-inner">
                <p className="v2-section-label">Our Capabilities · 05</p>
                <h1 className="pfc-page-hero-title">Environmental Testing - Martin Test Labs</h1>
                <p className="pfc-page-hero-sub">
                    Vibration, shock, environmental, altitude, thermal, non-destructive and mechanical testing - all performed in-house at Martin Testing Laboratories, a PFC division.
                </p>
            </div>
        </section>

        <section className="cap-section">
            <div className="cap-section-inner">
                <div className="cap-cards-3">
                    <div className="cap-panel">
                        <h3 className="cap-panel-heading">Vibration &amp; Shock</h3>
                        <ul className="cap-list">
                            <li>Random vibration</li>
                            <li>Swept-sine vibration</li>
                            <li>Mixed-mode vibration</li>
                            <li>SRS shock synthesis</li>
							<li>Classical shock</li>
							<li>Quasi-acceleration</li>
                        </ul>
                    </div>
                    <div className="cap-panel">
                        <h3 className="cap-panel-heading">NDT &amp; Mechanical Testing</h3>
                        <ul className="cap-list">
                            <li>Dye-Penetrant (NDT-PT)</li>
							<li>Magnetic Particle (NDT-MT)</li>
							<li>Eddy-Current (NDT-ET)</li>
							<li>Load proofing and testing</li>
							<li>Hardness characterization</li>
							<li>Fatigue and life limits</li>
							<li>Impact toughness and measurement</li>
							<li>Metallography and grain inspection</li>
                            
                        </ul>
                    </div>
                    <div className="cap-panel">
                        <h3 className="cap-panel-heading">Environmental Testing</h3>
                        <ul className="cap-list">
                            <li>Thermal dwells, ramps, and shock</li>
							<li>Altitude & vacuum</li>
							<li>Humidity and condensation</li>
							<li>Salt-fog exposure</li>
							<li>UV radiation degradation</li>
							<li>Coating thickness and abrasion resistance</li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>

        <CapabilitySections slug="environmental-testing" />

        <CapabilityPageNav currentSlug="environmental-testing" />
    </V2Layout>
)

export default EnvironmentalTestingPage
